import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=1060f894&scoped=true&"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./TheBreadcrumb.vue?vue&type=style&index=0&id=1060f894&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060f894",
  null
  
)

export default component.exports